import './styles.scss'
import React from 'react'
import { COFFEE_CAFES } from 'Utils/Constants'
import { getLocalUserDetails } from 'Utils/LocalStorage_Handler'

const CoffeeCafes = () => {
  const userDetails = getLocalUserDetails()

  return (
    <div className={`coffee-cafes-container ${userDetails?.id ? 'logged-in' : 'guest-user'}`}>
      <video controls className="coffee-cafes-image" autoPlay loop playsInline>
        <source src={COFFEE_CAFES.video} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  )
}

export default CoffeeCafes
